<template>
  <div id="chart">
    <VueApexCharts :type="chartType" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'Chart',
  props: {
    chartOptions: {
      type: Object,
      required: true
    },
    series: {
      type: Array,
      required: true
    },
    chartType: {
      type: String,
      default: 'column'
    }
  },
  components: {
    VueApexCharts
  }
}
</script>
<style scoped lang="scss">
::v-deep .apexcharts-toolbar {
  display: none !important;
}

#chart {
  @include sm-and-down {
    width: 600px;
  }
}
</style>
